// extracted by mini-css-extract-plugin
module.exports = {"header":"header-7oz49qqI clearfix","logo":"logo-3n3udMTC"};